import { useStaticQuery, graphql } from 'gatsby'

export const useWelcomeQuery = () => {
  const { wpPage } = useStaticQuery(graphql`
    query WelcomeQuery {
      wpPage(title: { eq: "Home" }) {
        welcome {
          welcome {
            title
            subtitle
            text
            link {
              title
              url
            }
            vimeoVideoId
            playButton {
              sourceUrl
            }
            image {
              sourceUrl
              mediaDetails {
                width
                height
              }
            }
            altText
            vanImageDesktop {
              sourceUrl
              mediaDetails {
                width
                height
              }
            }
            vanAltText
          }
        }
      }
    }
  `)
  return wpPage.welcome.welcome
}
